export const BUSINESS_METRICS = {
  operationalCosts: {
    percentage: 0.4, // 40% da receita
    description: "Custos operacionais médios do setor de arquitetura"
  },
  profitMargin: {
    percentage: 0.3, // 30% de margem de lucro
    description: "Margem de lucro média do setor de arquitetura"
  }
};